export default __webpack_public_path__ + "static/media/img (2).302201b4.jpg";